<template>
<v-container>
  <v-snackbar
      v-model="showErr"
      :color="errorCode==0?'success':'error'"
      multi-line
      :timeout="3000"
      top
    >
      {{ errorMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn

          text
          v-bind="attrs"
          @click="()=>{errorMsg = '';showErr=false;}"
        >
          close
        </v-btn>
      </template>
  </v-snackbar>
  <v-data-table
    ref="dataTable"
    :headers="headers"
    :items="dataTableItems.filter(
      e=>{
        if(searchQuery)
          switch(searchQuery[0]){
            case '#':
              return e.EiTag.toLowerCase().includes(searchQuery.toLowerCase());
            case '.':
              return e.EiType.toLowerCase().includes(searchQuery.toLowerCase());
            default:
              return e.EiName.toLowerCase().includes(searchQuery.toLowerCase());
          }
        else return true;
      })"
    class="elevation-1 no-hover"
    :page.sync="page"
    :items-per-page="itemsPerPage"
    :loading="searching"
    loading-text="Loading... Please wait"
    hide-default-footer
    @page-count="pageCount = $event"
    style="vertical-align: middle;"
  >
  <template v-slot:header.EiName="{ header }" >
    <span class="text-center">{{header.text}}</span>
  </template>
    <template v-slot:item.EiName="{ item }" align-center>
      <div style="display:flex;align-items:center;cursor:pointer;" @click="itemAction(item)">
        <v-img
          v-if="iconType.has(item.EiType)&&iconType.get(item.EiType).startsWith('/')"
          :src="iconType.get(item.EiType)"
          :max-height="25"
          :max-width="25"
          style="display:inline-flex;"
          >
        </v-img>
        <v-icon v-else>
          {{ iconType.has(item.EiType)?iconType.get(item.EiType):'mdi-cloud' }}
        </v-icon>
        {{'　' + item.EiName }}
      </div>
    </template>
    <template v-slot:item.EiType="{ item }">
      <div class="mr-3" >{{item.EiType}}</div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        v-if="accessType=='favorite'"
        class="mr-2"
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
      <v-icon
        class="mr-2"
        @click="itemConfig(item)"
      >
        mdi-cog
      </v-icon>
    </template>
    <template v-slot:item.status="{ item }">
      <v-icon :color="item.status==undefined?'grey':item.status?'green':'red'" class="mr-2">
        mdi-checkbox-blank-circle
      </v-icon>
    </template>
      <template v-slot:item.selected="{ item }" >
          <v-container class="d-flex justify-center pa-0">
            <v-simple-checkbox
            color="primary"
            @input="handleCheckbox(item)"
            :value="selectedDevice.has(item.EiName)"
            >
            </v-simple-checkbox>
          </v-container>
      </template>
    <template v-slot:top>
          <v-container>
            <v-row>
              <v-col sm="2" cols="12">
                <v-select
                  v-model="accessType"
                  :items="accessTypeList"
                  label="Select type"
                  dense
                  outlined
                  hide-details
                />
              </v-col>
              <v-col sm="8" cols="12">
                <v-form @submit.prevent="onSearchClick">
                  <v-text-field
                        v-model="searchQuery"
                        ref="searchDevice"
                        hide-details
                        dense
                        filled
                        class="expanding-search"
                        placeholder="Search device"
                        v-click-outside="{
                        handler: onSearchOutsideClick,
                        include: searchInclude,
                        }"
                  >
                    <template v-slot:append>
                        <v-icon class="search-include"  v-show="searchQuery" @click="searchQuery=''">
                          {{'mdi-close'}}
                        </v-icon>
                        <v-progress-circular v-show="searching" :size="24" indeterminate></v-progress-circular>
                        <v-tooltip
                        bottom
                        >
                          <template v-slot:activator="{ on }">
                            <v-icon class="search-include"  v-show="!searching" @click="onSearchClick" :disabled="!mmsReady" v-on="on">
                              {{'mdi-magnify'}}
                            </v-icon>
                          </template>
                          <span>Direct click to get nearby devices <br/>
                            or input something to search device</span>
                        </v-tooltip>
                    </template>
                  </v-text-field>
                </v-form>
              </v-col>
              <v-col sm="2" cols="12">
                <v-select
                  v-model="search"
                  :items="types"
                  label="Select type"
                  dense
                  outlined
                  hide-details
                >
                </v-select>
              </v-col>
          </v-row>
        </v-container>
    </template>
  </v-data-table>
  <v-row class="text-center pt-2">
    <v-col sm="2" cols="0">
      <v-btn  color="success" v-if="accessType=='favorite'" @click="addMoteDialog=true">
        add
      </v-btn>
    </v-col>
    <v-col sm="8" cols="12">
    <v-pagination
      v-model="page"
      :length="pageCount"
    ></v-pagination>
    </v-col>
    <v-col  sm="1" cols="12" align-self="center">
      <v-btn v-if="selectedDevice.size>0&&accessType!='favorite'" tile color="primary" @click="setMyList">
        save
      </v-btn>
    </v-col>
    <!--<v-text-field
      :value="itemsPerPage"
      hide-details
      label="Items per page"
      type="number"
      min="-1"
      max="15"
      @input="itemsPerPage = parseInt($event, 10)"
    ></v-text-field>-->
  </v-row>
  <AddMoteDialog :visible="addMoteDialog"  @addMote="addMote" @close="addMoteDialog=false"/>

</v-container>
</template>
<style lang="scss" scoped>
  .v-input--selection-controls__input{
    margin-right: 0;
  }

  ::v-deep .v-data-table{
    tbody{
      tr:hover{
        background: inherit !important;
      }
    }
  }
</style>
<script>

import conf from "@/config/config";
import {
  set as setCookie,
  get as getCookie
} from "es-cookie";
import webmms from "webmms-client";
import AddMoteDialog from "@/components/page-components/nearby/AddMoteDialog"
import {types} from "@/config/type"
import img_ss from '@/assets/smartscreen_512x512.png'
import img_mote from '@/assets/mote_512x512.png'

export default {
    name:'SearchResultList',
    props:[],
    components:{
      AddMoteDialog
    },
    data(){
        return {
          //user:this.$store.state.user,
          toggleAll:false,
          showErr:false,
          iconType:new Map([
            ['.tv',img_ss],
            ['.ss',img_ss],
            ['.mote',img_mote],
            ['.cam','mdi-camera'],
            ['.mms','mdi-send'],
            ]),
          page:1,
          addMoteDialog:false,
          itemsPerPage:10,
          pageCount:0,
          searching:false,
          showMenu:false,
          searchQuery:"",
          errorMsg:"",
          typeToListMap:new Map([
            ['.tv','ss-list'],
            ['.ss','ss-list'],
            ['.mote','mote-list']
            ]),
          dataTableItems:[],
          searchQueryResult:[],
          search:"all",
          types:types,
          accessType:'favorite',
          accessTypeList:['favorite','my','public'],
          headers: [
                {
                  text: 'Name',
                  align: 'start',
                  value: 'EiName',
                },
                {
                    text:"Type",
                    value:"EiType",
                    align: 'center',
                    filter: value => {
                    if (!this.search||this.search=='all') return true
                    return value == this.search;
                    }
                },
                { text:'Actions', value: 'actions',align: 'center', sortable: false },
                { text:'Status',value:'status',align: 'center'},
                { text:'Selected',value:'selected',align: 'center', sortable: false }
          ],
          selectedDevice:new Map(),
          myDevices:{},
          myDevicesData:[],
          params: null,
          error: true,
          errorCode:0,
          errorLoading: false,
          msg: "",
          err:"",
          mmsReady: false,
          mms: null,
          eiInfo: {
            eiName: "",
            eiTag: "",
            ddn: ""
          },
          EiToken:null,
          SToken:null,
          webmmsOptions:{
            EiToken:"",
            SToken:"",
            UToken:""
          },
          ddn:"",
          topic:"",
          payload:null,
          func:null
      }
    },
    watch:{
      search(val){

      },
      accessType(val){
        switch(val){
          case 'public':this.dataTableItems=this.searchQueryResult;break;
          case 'favorite':this.dataTableItems=this.myDevicesData;break;
          default:this.dataTableItems=[];
        }
        this.selectedDevice.clear();
      },
      selectedDevice(val){
        console.log(val)
      },
      myDevicesData(val){
        if(this.accessType=='favorite'){
          this.dataTableItems=val;
        }
      },
     async mmsReady(){
        if(this.mmsReady){
            if(this.$route.query.q){
              console.log(this.$route.query.q);
              if(this.$route.query.q=='all')
                this.onSearchClick();
              else{
                this.searchQuery=decodeURIComponent(this.$route.query.q);
                this.onSearchClick();
            }
          }
          this.searching=true;
          this.myDevices=await this.loadMyDevices();
          this.searching=false;
          console.log(this.myDevices);
          if(!this.myDevices){
            let [{ Reply: result }] = await this.mms.callMMS({
               topic: "",
               DDN: conf.objstore,
               func:  "obj://add",
               payload: {
                access:'private',
                uid:this.user.Uid,
                title: 'myDevices', name: 'myDevices', qname: 'myDevices',
                qcode: Date.now().toString(),
                qdigit: null,
                type: 'object',
                qtag: '',
                data: {'ss-list':[],'mote-list':[]}
                }
            });
            if(result.ErrMsg == 'OK'){
                this.errorCode=0;
                this.errorMsg='OK';
                this.showErr=true;
                console.log(`myDevices added:`,result);
            }
            else
                this.errorMsg = result.ErrMsg;
                this.showErr=true;
          }else{
            this.myDevicesData=Object.values(this.myDevices.data).flat();
            this.myDevicesData.forEach((e,i)=>{
                if(e.EiType=='.mote'){
                  this.checkMoteStatus(e,i,this.myDevicesData);
                }
              });
            if(this.accessType=='favorite')this.dataTableItems=this.myDevicesData;
          }
        }
      }
    },
    computed:{
      user(){
        return this.$store.getters.user;
      }
    },
    methods:{
      handleCheckbox(item){
        this.selectedDevice.has(item.EiName)?this.selectedDevice.delete(item.EiName):this.selectedDevice.set(item.EiName,item);
        this.$forceUpdate();
        console.log(this.selectedDevice);
      },
      log(...val){
        console.log(...val);
      },
      checkDupeAndAdd(array,type,item){
            let updatedData=this.myDevices.data?this.myDevices.data[type]:[];
            console.log([...array]);
            if(updatedData){
              let set=new Set(updatedData.map(e=>e.EiName));
             [...array].forEach(e=>{
                if(!set.has(e[0]))
                  updatedData.push(e[1]);
              })
              item['data'][type]=updatedData;
            }else item['data'][type]=[...array].map(e=>e[1]);
            return item;
      },
      async addMote(data){
        console.log(data);
        let newItem =Object.assign({},this.myDevices);
        let type=this.typeToListMap.get(data.EiType);
        if(type==undefined){
          this.errorCode=-10303;
          this.errorMsg = 'Invalid Type';
          this.showErr=true;
          return;
        }
        let userData=this.myDevices.data?this.myDevices.data[type]:[];

        let newData={
          EiName:data.EiName,
          DcUDID:data.DcUDID,
          DDN: "",
          AppId: "",
          EiType: data.EiType,
          EiTag: null,
          EiLoc: null,
          DcMMA: "",
          EiMMA: "",
          WIP: "",
          LIP: "",
          selected: false,
          status: false
        }
        if(userData){
          let set=new Set(userData.map(e=>e.EiName));
          if(!set.has(newData['EiName']))
            userData.push(newData);
          newItem['data'][type]=userData;
        }else newItem['data'][type].push(newData);
        let [{ Reply: result }] = await this.mms.callMMS({
             topic: "",
             DDN: conf.objstore,
             func: "obj://set",
             payload: newItem
          });
          if(result.ErrMsg == 'OK'){
            this.errorCode=0;
            this.errorMsg='OK';
            this.showErr=true;
            console.log('update result:',result);
            this.myDevices=result.Data;
            this.myDevicesData=Object.values(this.myDevices.data).flat();
          }else{
              this.errorCode = result.ErrCode;
              this.errorMsg = result.ErrMsg;
              this.showErr=true;
          }
      },
      async deleteItem(item){
          let title=this.typeToListMap.get(item.EiType);
          let index=this.myDevices.data[title].findIndex(e=>e.EiName==item.EiName);
          this.myDevices.data[title].splice(index,1);
          console.log(title,this.myDevices.data[title]);
        let [{ Reply: result }] = await this.mms.callMMS({
             topic: "",
             DDN: conf.objstore,
             func: "obj://set",
             payload: this.myDevices
          });
          if(result.ErrMsg == 'OK'){
            this.selectedDevice.clear();
            this.errorCode=0;
            this.errorMsg='OK';
            this.showErr=true;
            console.log('update result:',result);
            this.myDevices=result.Data;
            this.myDevicesData=Object.values(this.myDevices.data).flat();
          }else{
              this.errorMsg = result.ErrMsg;
              this.showErr=true;
          }
      },
      async setMyList(){
        if(!this.checkWebMMSState)
            return;
        if(!this.selectedDevice)
            this.selectedDevice.clear();
        let newItem =Object.assign({},this.myDevices);
        newItem=this.checkDupeAndAdd(this.selectedDevice,this.typeToListMap.get(this.search),newItem);

        let [{ Reply: result }] = await this.mms.callMMS({
             topic: "",
             DDN: conf.objstore,
             func: "obj://set",
             payload: newItem
          });
          if(result.ErrMsg == 'OK'){
            this.selectedDevice.clear();
            this.errorCode=0;
            this.errorMsg='OK';
            this.showErr=true;
            console.log('update result:',result);
            this.myDevices=result.Data;
            this.myDevicesData=Object.values(this.myDevices.data).flat();
          }else{
              this.errorMsg = result.ErrMsg;
              this.showErr=true;
          }
      },
      async loadList(){
          let payload;
          const { sortBy, descending, page, rowsPerPage } = this.pagination;

          let sort = {};
          if (sortBy && sortBy != "") {
              sort[sortBy] = descending ? -1 : 1;
          }else{
            sort = {name : 1};
          }

          payload = {
              page: page - 1,
              limit: rowsPerPage,
              sort : sort,
              noCache: true,
              allData: true,
              exclude: { data: 0}
          }

          if(!this.model || this.model.length == 0)
          {
            payload.condition = {uid: this.user.Uid};

          }else{
             if(this.model.startsWith('/'))
                payload.condition = { path : {$regex: this.model + '.*'}, uid: this.user.Uid};
             else if(this.model.startsWith('#'))
                payload.condition = { qtag : {$regex: this.model.substring(1) + '.*'}, uid: this.user.Uid};
             else if(this.model.startsWith('qname:'))
                payload.condition = { qname : { $regex: this.model.substring(6) + '.*'}, uid: this.user.Uid};
             else if(this.model.startsWith('qcode:'))
                payload.condition = { qcode : { $regex: this.model.substring(6) + '.*'}, uid: this.user.Uid};
            else if(this.model.startsWith('p:#'))
                payload.condition = { qtag : {$regex: this.model.substring(3) + '.*'}};
             else if(this.model.startsWith('p:qcode:'))
                payload.condition = {  qcode : {$regex: this.model.substring(8) + '.*'}, $or: [{access: 'public'}, {access: null}]};
             else if(this.model.startsWith('p:qname:'))
                payload.condition = {  qname : {$regex: this.model.substring(8) + '.*'}, $or: [{access: 'public'}, {access: null}]};
             else if(this.model.startsWith('p:'))
                payload.condition = {  $or: [{access: 'public'}, {access: null}]};
             else
                payload.condition = { qname : {$regex: this.model + '.*'}, uid: this.user.Uid};

          }
          if(this.accessType == 'favorite'){
            //payload.condition.access = 'private';
          }
          else {
            //payload.condition.$and = { $or : [{access: 'public'}, {access: null}]};
            delete payload.condition['uid'];
          }


          payload.condition.type = this.typeModel;

          console.log(payload);

          if(!this.checkWebMMSState())
            return;

          this.isLoading = true;
          // let [{ Reply: result, IN: state }] = await this.mms.callMMS({
          //     topic: "",
          //     DDN: this.yp.ddn,
          //     func: "FindObj",
          //     payload: payload
          // });

          let res = await this.mms.callMMS({
              topic: '',
              DDN: conf.objstore,
              func: "obj://list",
              payload: payload
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  let data = result.Reply.Data;
                  this.result = data.Data;
                  this.totalItems = data.TotalCount;
                }else{
                  this.result = [];
                  this.totalItems = 0;
                }
            }


          // this.result = this.entries.filter( item => {
          //     return item.name.toLowerCase().includes(this.model.toLowerCase());
          // });
      },
      async loadMyDevices(){
          let payload;

          payload = {
              noCache: true,
              allData: true,
              condition: {'qname':'myDevices','uid':this.user.Uid }
          }


          if(!this.checkWebMMSState())
            return;

          this.isLoading = true;

          let res = await this.mms.callMMS({
              topic: '',
              DDN: conf.objstore,
              func: "obj://list",
              payload: payload
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  let data = result.Reply.Data;
                  return data.Data[0];
                }else{
                  return {};
                }
            }

      },
      itemAction(item){
        switch(item.EiType){
          case '.cam':
            break;
          case '.tv':
            this.$router.push(`remote/tv/${item.DDN}`);
            break;
          case '.mote':
            this.$router.push({path:'pm',query:{udid:item.DcUDID,action:'keyBot'}});
            break;
        }
      },
      itemConfig(item){
        switch(item.EiType){
          case '.cam':
            break;
          case '.tv':
            this.$router.push(`remote/tvconfig/${item.DDN}`);
            break;
          case '.mote':
            this.$router.push({path:'pm',query:{udid:item.DcUDID}});
            break;
        }
      },
      populateSearchResult(result){
        this.searching=false;
        console.log(result);
        if(result.ErrCode==0){
          this.searchQueryResult=result.result.length>0?result.result/*.filter(e=>e.EiName!=null)*/:[];
          this.searchQueryResult.forEach((e,i)=>{

            e.selected=false;
            if(e.EiType=='.mote'){
              this.checkMoteStatus(e,i,this.searchQueryResult);
            }
            else
              e.status=true;
            });

          this.dataTableItems=this.searchQueryResult;

        }
        else{
          switch(result.ErrCode){
            case -32001:
              this.errorMsg=`Retreiving device timeout,
              Please specify device or type`;
              break;
            default:
              this.errorMsg="Retreiving device error";
            break;
          }
          this.showErr=true;
        }
        this.showMenu=true;

      },
      async checkMoteStatus(item,index,arr){
        let moteDDN='>h3/'+item.DcUDID+'/mote-app';
        let res;
        let payload={
                    "operate": "list",
                    "type": "snap"
                  };
        arr[index].status=undefined;
        try {
          res = await this.mms.sendMMS({
                  DDN:moteDDN,
                  topic:'mote://apt',
                  payload:this.isJson(payload) ? JSON.parse(payload) : payload
                });
          if(res[0].IN.State.ErrCode==0){
            arr[index].status=true;

          }else{
            arr[index].status=false;
          }
        } catch (error) {
          arr[index].status=false;
        }
        this.$forceUpdate();

      },
      searchInclude(){
        return [document.querySelector('.search-include')];
      },
      onSearchOutsideClick(){
        this.showMenu=false;
      },
      onSearchClick(){
        if(!this.mmsReady){
          console.log("mms not ready.");
          return;
        }
        if(this.accessType!='public')return;
        this.searching=true;
        let data={SToken: this.webmmsOptions.SToken};
        if(this.searchQuery||(!this.searchQuery&&(this.search!='all')))
          data.Keyword=this.searchQuery?this.searchQuery:this.search;
        this.mms.socket.emit('request', {
          func: data.Keyword?'search':'nearby',
          data: data
        }, reply=>this.populateSearchResult(reply));
      },
      async subscribeMMS() {
      this.removeEvent = this.mms.on("registered", async reply => {
        if(process.env.NODE_ENV!= 'production')
          console.log('reply=%s', JSON.stringify(reply))
        if (reply.ErrMsg == "OK") {
          this.eiInfo.ddn = reply.result.DDN;
          this.webmmsOptions.EiToken = reply.result.EiToken;
          this.webmmsOptions.SToken = reply.result.SToken;
          this.webmmsOptions.UToken = reply.result.UToken;
          if (this.eiInfo.eiName == "") {
            this.eiInfo.eiName = reply.result.EiName
              ? reply.result.EiName
              : "pgNEARBY" + this.makeId(5);
          }
          if (this.eiInfo.eiTag == "") {
            this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : "";
          }
          this.mmsReady = true;
          this.error = false;
        } else {
          this.mmsReady = false;
          this.error = false;
        }

        setCookie("EiToken", this.webmmsOptions.EiToken);
        setCookie("SToken", this.webmmsOptions.SToken);

        console.log("regtoCenter: %s", reply.ErrMsg);

        let deviceInfo = {
          DDN: this.eiInfo.ddn,
          EiOwner: "",
          EiName: this.eiInfo.eiName,
          EiType: ".page",
          EiTag: this.eiInfo.eiTag,
          EiLoc: ""
        };
        let result = await this.mms.setDeviceInfo(deviceInfo);

        console.log(`SetDevice reply=${JSON.stringify(result)}`);
        await this.track(this.mms, 'nearby');
      });

      this.mms.on("message", (method, from, data, body) => {
        this.mmsReady = true;
        this.error = false;
        console.log(`rcve: from=${JSON.stringify(from)}, data=${data}`);
        this.msg=`
             method: ${method}
             from: ${JSON.stringify(from)}
             data: ${data}
             ack: ${body}
         `
        //body();
        if (typeof data == "object" && !data.from) data.from = from;
        //body.sender = data;
        if (data) {
          //this.eventList.push(data.data);
          //this.setLog({From : from, Data: data}, 'In');
        }
      });

      this.mms.on("state", msg => {
        console.log("WS error: %s", msg);
        this.mmsReady = false;
        this.error = true;
        this.loading = false;
      });

      this.mms.on("disconnect", msg => {
        console.log(msg);
        this.mmsReady = false;
        this.error = true;
        this.loading = false;
      });

      this.mms.on("error", err => {
        console.log(err);
        this.mmsReady = false;
        this.error = true;
        this.loading = false;
      });

      this.mms.on("connect_error", err => {
        console.log(err);
        this.mmsReady = false;
        this.error = true;
        this.loading = false;
      });

      this.mms.on("connect_timeout", err => {
        console.log(err);
        this.mmsReady = false;
        this.error = true;
        this.loading = false;
      });
      window.setTimeout(()=>this.checkWebMMSState(),5000);
      },
      checkWebMMSState(){
        if(!this.mmsReady)
        {
          this.errorCode=-1;
          this.errorMsg = "WebMMS is not connected or registered.";
          this.showErr=true;
          return false;
        }else return  true;

      }
    },
    async created(){
      this.EiToken=getCookie('EiToken')||'';
      this.SToken=getCookie('SToken')||'';
      this.mms=webmms({wsurl:conf.wsurl,EiToken:this.EiToken,SToken:this.SToken});
    },
    async beforeMount() {
      await this.subscribeMMS();
    },
    beforeDestroy() {
      this.removeEvent();
    }

}
</script>
